export default __webpack_public_path__ + "static/media/pic4.2bc8a85a.jpg";